import { Container, Grid, TextField, Typography, Divider, CircularProgress, createMuiTheme } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { login, testApi, persistantLogin } from "../actions";
import { textValidate, deviceData, getThisYear, createMarkup, remoteURL } from "../common";
import { SaspButton, CopyrightWidgetLoading } from "../components";
import DeregisterScreen from "./DeregisterScreen";
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { getLocalStorage } from "../common";

import LoopIcon from '@material-ui/icons/Loop';
import { isMobileOnly, isTablet, isElectron, deviceDetect, deviceType, isBrowser } from 'react-device-detect';
import "../styles/masterStyles.css";
//TODO refactor into different reusable components/functions
//TODO test login function for real.

class LoginScreen extends Component {
    state = {
        id_email: "",
        password: "",
        disabled: true,
        id_email_flag: false,
        password_flag: false,
        id_email_error: false,
        password_error: false,
        errorMessage: "",
        errorModal: false,
        id_email_blur_flag: false,
        password_blur_flag: false,
        holdDevice: false,
        spinner: false,
        tracking: null,
        year: getThisYear(),
        showpassword: false,
    };

    componentDidMount = async () => {
        if (
            typeof getLocalStorage('login_dt') !== 'undefined' && 
            getLocalStorage('login_dt') != null
        ) {    
            const _date = new Date();
            let _expire = Number(getLocalStorage('login_dt'));
            const _now = Number(Date.parse(_date));

            if (_now < _expire) {
                await this.props.persistantLogin();
                this.props.history.replace('/splash');
                return null;
            }
        }

        document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        return this.setState({ ...this.state, tracking: deviceData(this.props.location, 'login') });
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.errorCode !== prevProps.errorCode) {
            this.setState({ ...this.state, errorMessage: this.props.errorMessage });
            if (this.props.errorMessage != '') {
                this.setState({ 
                    ...this.state, 
                    errorMessage: this.props.errorMessage, 
                    errorModal: true,
                    spinner: false
                });
            } else {
                this.setState({ 
                    ...this.state, 
                    errorMessage: '', 
                    errorModal: false,
                    spinner: false
                });
            }
        }

        if (this.state !== prevState) {
            if (this.state.disabled === true || prevState.disabled === true) {
                if (
                    this.state.password_flag === true &&
                    this.state.id_email_flag === true
                ) {
                    this.setState({
                        disabled: false
                    });
                }
            }
        }

        if (prevProps.holdDevice !== this.props.holdDevice) {
            if (this.props.holdDevice === 0) {
                this.setState({
                    ...this.state,
                    holdDevice: true
                });
            }
        }
    };

    doUserLogin = () => {
        this.setState({ ...this.state, spinner: true });
        return null;
    }

    login = async props => {
        await this.doUserLogin();
        await props.login({
            id_email: this.state.id_email,
            password: this.state.password,
            tracking: this.state.tracking
        });

        if (props.holdDevice === 0) {
            this.setState({
                holdDevice: true
            });
        }

        return null;
    };

    handleClickShowPassword = () => {
        return this.setState({ ...this.state, showpassword: !this.state.showpassword} );
    }

    handleMouseDownPassword = (event) => {
        event.preventDefault();
        return null;
    }

    handleText = (text, type) => {
        if (type === "id") {
            text.includes("@") ? (type = "email") : (type = "id");
            if (textValidate(text, type) === true) {
                this.setState({
                    id_email: text,
                    id_email_flag: true,
                    id_email_error: false
                });
            } else if (text.length < 1) {
                this.setState({
                    id_email: text,
                    id_email_flag: false,
                    id_email_error: false,
                    disabled: true
                });
            } else {
                this.setState({
                    id_email: text,
                    id_email_flag: false,
                    id_email_error: true,
                    disabled: true
                });
            }
        } else {
            if (textValidate(text, type) === true) {
                this.setState({
                    password: text,
                    password_flag: true,
                    password_error: false
                });
            } else if (text.length < 1) {
                this.setState({
                    password: text,
                    password_flag: false,
                    password_error: false,
                    disabled: true
                });
            } else {
                this.setState({
                    password: text,
                    password_flag: false,
                    password_error: true,
                    disabled: true
                });
            }
        }
    };

    onBlur = () => {
        if (this.state.id_email_error === true) {
            if (this.state.id_email_blur_flag === false) {
                this.setState({
                    id_email_blur_flag: true
                });
            }
        }
        if (this.state.password_error === true) {
            if (this.state.password_blur_flag === false) {
                this.setState({
                    password_blur_flag: true
                });
            }
        }
        if (this.state.id_email_error === false) {
            if (this.state.id_email_blur_flag === true) {
                this.setState({
                    id_email_blur_flag: false
                });
            }
        }
        if (this.state.password_error === false) {
            if (this.state.password_blur_flag === true) {
                this.setState({
                    password_blur_flag: false
                });
            }
        }
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            holdDevice: false
        });
        return null;
    };

    handleErrorClose = async () => {
        await this.setState({
            ...this.state,
            errorModal: false,
            errorMessage: ''
        });

        return null;
    }

    handleSpinnerClose = () => {
        this.setState({ ...this.state, spinner: false });
        return null;
    }

    render() {
        let bgsize = 'cover';
        let bgimg = "url('./static/media/loginBackground-3x.jpg')";

        if (isTablet || isElectron) { bgsize = 'contain'; bgimg = "url('./static/media/loginBackground-3x.png')"; }

        return (
            <Container
                className="login anchor flex-col-center margin-top-48"
                disableGutters={false}
                fixed={false}
                maxWidth="xl"
                style={{
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center",
                    // backgroundImage: bgimg,
                    // backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: bgsize,
                    height: "100vh !important",
                    width: "100vw !important",
                    position: "fixed !important",
                    top: "-60px",
                    left: "0",
                    bottom: "0",
                    right: "0",
                }}
            >
                <Grid className="loginGridContainer" container xs={12} sm={12} md={12} lg={12} xlg={12} xxlg={12}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: '16px', width: '100%'}}>
                        <div className="login-header">SASP App Login</div>

                        <img className="img-logo-img" src="https://university.auanet.org/mobileapps/assets/SASPAppIcon.png" alt="SASP App Icon" />
                    </div>

                    <div>
                        <form>
                            <FormControl className="width100" variant="outlined">
                                <InputLabel
                                    htmlFor="id_email"
                                    style={{
                                        top:"8px",
                                        // left: "16px",
                                        // zIndex: "1",
                                        // color:"#00567a",
                                        fontWeight:"400",
                                        backgroundColor: "#fff",
                                        padding: "4px 8px",
                                        borderRadius: "4px"
                                    }}
                                >
                                    AUA ID or Email
                                </InputLabel>

                                <OutlinedInput
                                    // placeholder="AUA ID or Email"
                                    label="AUA ID or Email"
                                    onBlur={this.onBlur}
                                    onChange={text => this.handleText(text.target.value, "id")}
                                    value={this.state.id_email}
                                    id="id_email"
                                    variant="outlined"
                                    error={this.state.id_email_error}
                                    style={{
                                        // padding: "12px 10px",
                                        margin: "6.5px 4px",
                                        backgroundColor: "#fff"
                                    }}
                                    inputProps={{
                                    'aria-label': 'weight',
                                    }}
                                />
                            </FormControl>
                        
                            {this.state.id_email_blur_flag ? (
                                <Grid className="errorTextContainer" item xs={12}>
                                    <Typography className="errorText" variant="body1">
                                        Please enter a valid username or email
                                    </Typography>
                                </Grid>
                            ) : (
                                <div style={{ marginTop: 15 }} />
                            )}

                            <FormControl className="width100" variant="outlined">
                                <InputLabel
                                    htmlFor="password"
                                    style={{
                                        top:"8px",
                                        // left: "16px",
                                        // zIndex: "1",
                                        // color:"#00567a",
                                        fontWeight:"400",
                                        backgroundColor: "#fff",
                                        padding: "4px 8px",
                                        borderRadius: "4px"
                                    }}
                                >
                                    Password
                                </InputLabel>

                                <OutlinedInput
                                    // placeholder="Password"
                                    label="Password"
                                    type={this.state.showpassword ? 'text' : 'password'}
                                    onBlur={this.onBlur}
                                    onChange={text =>
                                        this.handleText(text.target.value, "password")
                                    }
                                    value={this.state.password}
                                    id="password"
                                    variant="outlined"
                                    error={this.state.password_error}
                                    style={{
                                        // padding: "12px 10px",
                                        margin: "6.5px 4px",
                                        backgroundColor: "#fff"
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                                onClick={this.handleClickShowPassword}
                                                onMouseDown={this.handleMouseDownPassword}
                                            >
                                                {this.state.showpassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            {this.state.password_blur_flag ? (
                                <Grid className="errorTextContainer" item xs={12}>
                                    <Typography className="errorText" variant="body1">
                                        Please enter a valid password
                                    </Typography>
                                </Grid>
                            ) : (
                                <div style={{ display: "none" }} />
                            )}
                        </form>
                    </div>

                    <Grid className="loginButtonContainer" item xs={12}>
                        {this.state.disabled ? (
                            <SaspButton
                                className="loginButton"
                                component={Link}
                                to={"/home"}
                                disabled={true}
                            >
                                Login
                            </SaspButton>
                        ) : (
                            <SaspButton
                                className="loginButton"
                                onClick={() => this.login(this.props) }
                            >
                                Login
                            </SaspButton>
                        )}
                    </Grid>

                    <Grid className="" style={{width: 'calc(100% - 8px)', margin: '24px 4px 8px', textAlign: 'center'}} item xs={12}>
                        <Link 
                            onClick={() => remoteURL('https://university.auanet.org/passwordreset')} 
                            style={{
                                color: 'white',
                                borderBottom: '1px solid white'
                            }}
                        >
                            Reset Password
                        </Link>
                    </Grid>

                    <Grid item xs={12}>
                        <div className={'login-notice'}>
                            <h4>Notice</h4>
                            <p>
                                You are prohibited from using or uploading content you accessed through this mobile application into external applications, bots, software, or websites, including those using artificial intelligence technologies and infrastructure, including deep learning, machine learning and large language models and generative AI.
                            </p>
                        </div>
                    </Grid>

                    <Grid item xs={12}>
                        <CopyrightWidgetLoading 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-24 padding-top-8 padding-bottom-8 padding-left-16 padding-right-16"
                        />
                    </Grid>
                </Grid>

                <Modal
                    aria-labelledby="simple-modal"
                    aria-describedby="simple-modal-description"
                    open={this.state.holdDevice}
                    onClose={this.handleClose}
                >
                    <DeregisterScreen />
                </Modal>

                <Modal
                    aria-labelledby="error-modal"
                    aria-describedby="error-modal-description"
                    open={this.state.errorModal}
                    onClose={this.handleErrorClose}
                    style={{
                        display:"flex",
                        flexDirection:"column",
                        justifyContent:"center",
                        alignItems:"center",
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            backgroundColor: "#fff",
                            border: '2px solid #00567a',
                            borderRadius: "8px",
                            padding: "8px 16px 16px",
                            maxHeight: '75vh',
                            overflow: 'auto',
                            outline: "none"
                        }}
                    >
                        <div className="flex-col-start">
                            <div style={{ width: "100%", marginBottom: "16px"}} >
                                <Typography className="homeDividerText" style={{margin: "0", padding: "0.5em"}}>Login Error</Typography>
                                <Divider className="SASPTestsDivider" style={{margin: "0", width: "100%"}} />
                            </div>
                            <div 
                                style={{padding: "0.5em"}}
                                dangerouslySetInnerHTML={createMarkup(this.state.errorMessage)
                            }>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    aria-labelledby="spinner-modal"
                    aria-describedby="spinner-modal-description"
                    open={this.state.spinner}
                    onClose={this.handleSpinnerClose}
                    style={{
                        display:"flex",
                        flexDirection:"column",
                        justifyContent:"center",
                        alignItems:"center",
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            backgroundColor: "transparent",
                            border: 'none',
                            maxHeight: '75vh',
                            width: '88vw',
                            maxWidth: "300px",
                            overflow: 'auto',
                            outline: "none",
                            display: "flex",
                            flexDirection:"column",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <CircularProgress style={{fontSize: "2em"}} className="text-white margin-bottom-16"/>
                        <h3 className="text-white">LOADING...</h3>
                    </div>
                </Modal>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    const { auth, holdDevice, errorMessage, errorCode } = state.auth;
    return { auth, holdDevice, errorMessage, errorCode };
};

export default connect(mapStateToProps, { login, testApi, persistantLogin })(LoginScreen);
